import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import MetricResponsesList from './MetricResponsesList'

export default function MetricResponses() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/metric_responses" component={MetricResponsesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}